import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./homeFeatures.css";

const features = [
    {
        title: "Equipment management",
        description: "Inventory, component assemblies, locations and movement history.",
        icon: <><rect x="4" y="7" width="16" height="13" rx="2" /><path d="M9 7V4h6v3M4 12h16M10 12v3h4v-3" /></>
    },
    {
        title: "Jobs and quotations",
        description: "Create quotes, manage jobs, allocate equipment and record returns.",
        icon: <><rect x="5" y="4" width="14" height="17" rx="2" /><path d="M9 4V2h6v2M9 9h6M9 13h6M9 17h4" /></>
    },
    {
        title: "Parts and stock",
        description: "Full stock control: purchase orders, deliveries, stock takes and pick lists. Trace parts from stock through to use in equipment.",
        icon: <><path d="m12 3 9 5-9 5-9-5 9-5ZM3 8v9l9 5 9-5V8M12 13v9M7.5 5.5l9 5" /></>
    },
    {
        title: "Maintenance and certification",
        description: "Inspection records, service history, reminders and certificate documents.",
        icon: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Z" /><path d="m8 12 3 3 5-6" /></>
    },
    {
        title: "Reporting",
        description: "Equipment utilisation, job costs and item income.",
        icon: <><path d="M4 3v17h17M8 16v-4M13 16V8M18 16V5" /></>
    },
    {
        title: "QR codes",
        description: "Create labels and scan to open equipment records.",
        icon: <><rect x="3" y="3" width="6" height="6" rx="1" /><rect x="15" y="3" width="6" height="6" rx="1" /><rect x="3" y="15" width="6" height="6" rx="1" /><path d="M15 15h3v3h3v3h-6v-3M21 12v3M12 3v3M3 12h6M12 12v6" /></>
    }
];

export default function HomeFeatures() {
    return (
        <section id="features" className="home-features" aria-labelledby="home-features-heading">
            <div className="home-features-background" aria-hidden="true">
                <div className="home-features-monitor">
                    <div className="home-features-monitor-front" />
                    <div className="home-features-monitor-back" />
                </div>
            </div>
            <div className="home-features-inner">
                <header className="home-features-header">
                    <h2 id="home-features-heading">Everything your team needs, together.</h2>
                    <p>One cloud-based platform for equipment, jobs, stock and maintenance.</p>
                </header>
                <div className="home-features-grid">
                    {features.map(feature => (
                        <article className="home-feature-tile" key={feature.title}>
                            <span className="home-feature-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                    {feature.icon}
                                </svg>
                            </span>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </article>
                    ))}
                </div>
                <div className="home-features-actions">
                    <Link className="home-features-link" to="/Features">Explore all features <span aria-hidden="true">→</span></Link>
                    <HashLink smooth className="home-features-demo" to="/#contact">Book a demonstration</HashLink>
                </div>
            </div>
        </section>
    );
}
